"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TauntingShoutAbilityHandler = exports.TauntingShoutActorAbilityFactory = exports.TauntingShoutAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const Taunted_1 = require("../../core/effects/core/Taunted");
class TauntingShoutAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.TauntingShout;
        this.__typeName = "TauntingShout";
    }
}
exports.TauntingShoutAbilityArgs = TauntingShoutAbilityArgs;
let TauntingShoutActorAbilityFactory = class TauntingShoutActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("TauntingShout", "AllEnemies", 1);
    }
};
TauntingShoutActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("TauntingShout")
], TauntingShoutActorAbilityFactory);
exports.TauntingShoutActorAbilityFactory = TauntingShoutActorAbilityFactory;
let TauntingShoutAbilityHandler = class TauntingShoutAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "attacking",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                const targets = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
                targets.forEach(targetId => container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId,
                    duration: Duration_1.Duration.Turns(1),
                    effect: new Taunted_1.TauntedEffectArgs
                }));
            }
        });
    }
};
TauntingShoutAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.TauntingShout)
], TauntingShoutAbilityHandler);
exports.TauntingShoutAbilityHandler = TauntingShoutAbilityHandler;
